module.exports = __webpack_public_path__ + "static/img/ROUPS12VR_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ROUPS12VR_1.png
// module id = ua/G
// module chunks = 0